import { Subscription } from 'rxjs';

import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  OnInit,
  HostBinding,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';

import { Session } from '../../services/session';
import { FleetGrowthFeatureFlagService } from '@services/feature-flags/growth';

import { setCookie, getCookie } from '@lib/cookies';
import { CookieKey } from '@lib/cookie-keys.const';
import { mapValueToBoolean } from '@lib/utils';

@Component({
  selector: 'upsell-topbar',
  templateUrl: './upsell-topbar.component.html',
  styleUrls: ['./upsell-topbar.component.scss', '../../styles/upgrade.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpgradeTopBarComponent implements OnInit, OnDestroy {
  @Output() public onBannerClose = new EventEmitter();
  @Output() public onBannerOpen = new EventEmitter();
  public EoYTopBarStatus: boolean;
  public EoQTopBarStatus: boolean;
  public upgradeTopBarStatus: boolean;
  public trialRemainingDays: number;
  public isEOQUpsellQ12023Enabled: boolean;
  public isEOYUpsellEnabled: boolean;
  public showEoYUpsellTopBanner: boolean = false;
  public showEoQUpsellTopBanner: boolean = false;
  public learnMoreUrl: string = 'https://go.gomotive.com/WAPP-Promo-VGDC-Bundle-SMB_LP-Display.html';

  @HostBinding('class.hide') private bannerClosedEmitCalled: boolean = false;
  private el: HTMLElement;
  private isFeatureTrial: boolean;
  private routerSubscription: Subscription;

  constructor(
    public session: Session,
    el: ElementRef,
    private router: Router,
    private fgFeatureFlagService: FleetGrowthFeatureFlagService,
  ) {
    this.el = el.nativeElement;
    this.isFeatureTrial = session.isFeatureTrial();
    this.trialRemainingDays = session.featureTrialRemainingDays;
    this.isEOQUpsellQ12023Enabled = fgFeatureFlagService.isEOQUpsellQ12023Enabled();
    this.isEOYUpsellEnabled = fgFeatureFlagService.isEOYUpsellEnabled();
  }

  public ngOnInit(): void {
    this.onBannerClose.emit();

    this.upgradeTopBarStatus = !!this.getUpdateTopBarCookie ? mapValueToBoolean(this.getUpdateTopBarCookie) : true;
    this.EoYTopBarStatus = !!this.getEoYUpsellTopBarCookie ? mapValueToBoolean(this.getEoYUpsellTopBarCookie) : true;
    this.EoQTopBarStatus = !!this.getEoQUpsellTopBarCookie ? mapValueToBoolean(this.getEoQUpsellTopBarCookie) : true;

    if (this.isEOYUpsellEnabled && this.EoYTopBarStatus) {
      this.showEoYUpsellTopBanner = true;
      this.openTopBar();
    } else if (this.trialRemainingDays > 0 && this.upgradeTopBarStatus) {
      this.showEoYUpsellTopBanner = false;
      this.openTopBar();
    } else if (this.isEOQUpsellQ12023Enabled && this.EoQTopBarStatus && !this.session.isSweepStakesRequested) {
      this.learnMoreUrl = 'https://go.gomotive.com/motive-cards-sweepstakes-23.html';
      this.showEoQUpsellTopBanner = true;
      this.openTopBar();
    } else {
      this.bannerClosedEmitCalled = true;
    }
  }

  public ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  public openLearnMoreCTA(url: string): void {
    window.open(url, '_blank');

    if (!this.fgFeatureFlagService.isEOQUpsellQ12023Enabled()) {
      this.bannerClosedEmitCalled = true;
      this.onBannerClose.emit();
    }

    let cookieKey: string;
    if (this.showEoYUpsellTopBanner) {
      cookieKey = CookieKey.EOY_UPSELL_TOPBAR_STATUS;
      const currentYear = new Date().getFullYear();
      const targetDate = new Date(currentYear, 11, 31);
      // Expires on 31st December of the current year so the upsell won't show after EOY
      setCookie(cookieKey, false, { expires: targetDate });

    } else {
      cookieKey = CookieKey.EOQ_UPSELL_TOPBAR_STATUS;

      const currentDateNew: Date = new Date();
      const targetDateNew: Date = new Date(currentDateNew.getFullYear(), 3, 15);
      const daysUntilTargetDate: number = Math.ceil((targetDateNew.getTime() - currentDateNew.getTime()) / (1000 * 60 * 60 * 24));
      setCookie(cookieKey, true, { expires: daysUntilTargetDate });
    }
  }

  public openTopBar(): void {
    this.onBannerOpen.emit();
    this.bannerClosedEmitCalled = false;
  }

  public closeTopBar(): void {
    this.bannerClosedEmitCalled = true;
    this.onBannerClose.emit();

    if (this.showEoYUpsellTopBanner) {
      setCookie(CookieKey.EOY_UPSELL_TOPBAR_STATUS, false);
    } else if (this.showEoQUpsellTopBanner) {
      setCookie(CookieKey.EOQ_UPSELL_TOPBAR_STATUS, true);
    } else {
      setCookie(CookieKey.UPGRADE_TOPBAR_STATUS, false);
    }
  }

  public get getUpdateTopBarCookie(): any {
    return getCookie(CookieKey.UPGRADE_TOPBAR_STATUS);
  }

  public get getEoYUpsellTopBarCookie(): any {
    return getCookie(CookieKey.EOY_UPSELL_TOPBAR_STATUS);
  }

  public get getEoQUpsellTopBarCookie(): any {
    return getCookie(CookieKey.EOQ_UPSELL_TOPBAR_STATUS);
  }
}
